__turbopack_context__.v({
  "icon": "Icon-module__aAt37W__icon",
  "sized": "Icon-module__aAt37W__sized",
});
